import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "./PageLayout.module.scss";

type PageLayoutProps = {
  heading: string;
  description?: string;
  children?: React.ReactNode;
  heightAuto?: boolean;
  dashboardPage?: boolean;
};

const PageLayout: FC<PageLayoutProps> = ({ heading, description, children, heightAuto, dashboardPage }) => {
  const hasDescription = !!description;

  return (
    <div
      className={classes.container}
      style={{
        paddingTop: `${hasDescription || dashboardPage ? "40" : "24"}px`,
        height: `${heightAuto ? "auto" : "100vh"}`,
      }}
    >
      <div style={{ height: 80, marginTop: "4rem" }} />
      <Typography variant="h1" className={hasDescription || dashboardPage ? classes.headingExtra : classes.heading}>
        {heading}
      </Typography>

      {hasDescription ? <Typography className={classes.description}>{description}</Typography> : null}

      {children}
    </div>
  );
};

export default PageLayout;
